<template>
  <div>
    <appbar :showBorder="true" :dense="true">
      <template v-slot:custom-selectors>
        <div
          class="d-flex justify-space-between align-center"
          style="width: 100%; margin-left: 0px; gap: 0px"
        >
        <div
          v-if="
            $route.name === 'smart-guard' &&
            viewMode != 'evolution' &&
            (viewMode === 'alarmes' || viewMode === 'mixed')
          "
          class="date_selector_smart"
          
        >
      
          <div v-if="isWarningCondition" class="alert-wrapper">
            <v-icon
              @click="showAlert = !showAlert"
              :color="color_warning_msg"
              class="alert-icon"
            >
              mdi-alert
            </v-icon>
            <v-alert
              v-model="showAlert"
              v-show="showAlert"
              type="info"
              dense
              shaped
              dismissible
              :color="color_warning_msg"
              class="alert-popup"              
            >
              {{ warning_error_msg }}
            </v-alert>
          </div>
          <v-menu           
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-combobox
                v-model="dateRange"
                prepend-icon="mdi-calendar"
                :color="isDateModified ? 'orange' : 'grey darken-1'"
                readonly       
                hide-details        
                class="fleet-date-smart"
                v-bind="attrs"               
                v-on="on"
                @click="menu = true"
                @click:prepend="resetToMaxDate()"
              />
            </template>
            <v-date-picker
              v-model="tempDateRange"
              scrollable              
              :min="min_date"
              :max="maxDate"
            >
              <v-spacer></v-spacer>
              <v-btn text style="font-size: bold" @click="menu = false"
                >Annuler</v-btn
              >
              <v-btn text color="primary" @click="takedades">Rafraichir</v-btn>
            </v-date-picker>
          </v-menu>
        </div>
        </div>
      </template>
    </appbar>

    <div style="margin-top: 5px">
      <information
        :selected_date="dateRange"
        :list_total="list_dashboard"
        :list_parc="list_parc"
        :nbr_site="site"
      />
    </div>
    <div>
      <v-card
        style="
          flex: 1;
          margin-top: 10px;
          margin-left: 10px;
          margin-right: 10px;
          border-top: 10px;
          border-bottom: 0px;
          padding: 10px;
        "
      >
        <div class="btn">
          <v-btn @click="setChangebuttonname(0)">{{
            $t("_evolutions_")
          }}</v-btn>
          <v-btn @click="setChangebuttonname(1)">{{
            $t("_evolutions_/_alarmes_")
          }}</v-btn>
          <v-btn
            @click="setChangebuttonname(2)"
            :color="changelable === '_exit_' ? 'orange' : undefined"
            >{{ $t(changelable) }}</v-btn
          >
        </div>
      </v-card>
      <div style="display: flex">
        <v-card
        v-show="viewMode === 'evolution' || viewMode === 'mixed'"
          :style="{
            marginRight: viewMode === 'evolution' ? '8px' : '0',
            marginLeft: '5px',
            backgroundColor: '#f5f5f5',
            border: '5px solid orange',
            borderRadius: '5px',
          }"
          style="
            flex: 1;
            margin-left: 10px;
            border-radius: 0;
            margin-bottom: 20px;
          "
        >
          <evolutionSmartguard
            :change_size="viewMode === 'mixed'"
            :installation_id="Number(this.cur_install_id)"
          />
        </v-card>
        <v-card
        v-show="viewMode === 'alarmes' || viewMode === 'mixed'"
          :style="{
            marginLeft: viewMode === 'alarmes' ? '8px' : '0',

            marginRight: '10px',
          }"
          style="
            flex: 1;
            margin-right: 10px;
            border-radius: 0;
            margin-bottom: 20px;
          "
        >
          <alarmesalertes
            :selected_date="dateRange"
            :liste_alarmes="list_alarms"
            :nbr_site="site"
            :installation_id="Number(this.cur_install_id)"
          />
        </v-card>
      </div>
    </div>
    <div></div>
    <div>
      <v-row class="mb-2 px-4 pb-2">
        <v-col
          :class="selected_mode == '_historique_perf_' ? 'col-9' : 'col-12'"
        >
          <div class="d-flex" style="align-items: center">
            <div
              class="mode-choice"
              v-for="mode in modes"
              :key="mode"
              :class="{ active: mode == selected_mode }"
              @click="selected_mode = mode"
            >
              {{ $t(mode) }}
            </div>
          </div>
          <div style="margin-top: -10px; background-color: white">
            <div
              v-if="selected_mode === '_historique_perf_'"
              style="
                max-width: 250px;
                margin-left: 20px;
                margin-top: 10px;
                margin-bottom: -20px;
              "
            >
              <v-menu
                ref="menu"
                v-model="menu_two"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-combobox
                    v-model="dateRange_two"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @click="menu_two = true"
                    @click:prepend="initinstallation()"
                  ></v-combobox>
                </template>
                <v-date-picker
                  v-model="dates"
                  range
                  scrollable
                  :min="this.installation.audit_start_date"
                  :max="this.maxDate"
                >
                  <v-spacer></v-spacer>
                  <v-btn text style="font-size: bold" @click="menu_two = false"
                    >Annuler</v-btn
                  >
                  <v-btn text color="primary" @click="validatedate()"
                    >Rafraichir</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </div>
          </div>

          <installations-evo-perf
            :key="key_update + 1"
            :mode="selected_mode"
            :installation="installation"
            v-if="selected_mode === '_historique_perf_'"
          />
          <sante
            :key="key_update"
            :selected_date="dateRange"
            :checklistStatusdict="checklistStatus"
            v-if="selected_mode === '_etat_de_sante_'"
          />
          <!-- <router-link
            :to="{
              name: 'expert-kpi',
              params: {
                id: this.$route.params.id,
               },
              
            }"
          >
          <v-icon class="mr-2"> mdi-chart-bar-stacked </v-icon>
            {{ $t("_kpi_filter_") }}
          </router-link> -->
        </v-col>
        <installations-details-perf
          v-if="selected_mode === '_historique_perf_'"
          :installation="installation"
          :fromSmartguard="true"
        />
      </v-row>
    </div>
  </div>
</template>

<script>
import information from "./smart-guard/informations.vue";
import Appbar from "@/components/App/Appbar.vue";
import alarmesalertes from "./smart-guard/alarmesetalertes.vue";
import InstallationsDetailsPerf from "@/components/Installations/DetailsPerf";
import InstallationsEvoPerf from "@/components/Installations/EvoPerf";
import evolutionSmartguard from "./smart-guard/evolutionSmartguard.vue";
import { mapGetters } from "vuex";
import sante from "./smart-guard/etatsante.vue";
import api from "@/api/api";
import webconf from "../../utils/frontend_setup";

export default {
  components: {
    sante,
    Appbar,
    InstallationsDetailsPerf,
    InstallationsEvoPerf,    
    information,
    alarmesalertes,
    evolutionSmartguard,
  },

  data() {
    return {
      installation: {},
      viewMode: "alarmes",
      selected_mode: "_etat_de_sante_",   
      modes: ["_etat_de_sante_", "_historique_perf_"],
      key_update: 0,
      menu: false,
      menu_two: false,
      isDateModified: false,
      maxDate: new Date(Date.now() - 86400000).toISOString().substr(0, 10), // 86400000 ms = 1 day
      min_date: this.installation?.audit_start_date || '2016-01-01',
      dates: [],
      selectedDate: "",
      dateRange_two: "",
      tempDateRange_two: "",
      color_warning_msg: "orange",
      warning_error_msg:"",
      showAlert: false,
      dateRange: "",
      tempDateRange: "",
      list_parc: [],
      defaultDashboard: {
        nb_de_site: 0,
        pr_clean_parc: 0,
        pr_clean_parc_evo: 0,
        ip_clean_parc: 0,
        ip_clean_parc_evo: 0,
        pc_totale: 0,
        disponibilite_parc: 0,
        disponibilite_parc_evo: "_ ",
        pertes_recouvrables: "_ ",
        pertes_vs_modele_energie: "_ ",
        pertes_vs_modele_energie_evo: "_ ",
        major_alarms: 0,
        minor_alarms: 0,
        without_alarms: 0,
      },
      list_dashboard: {
        nb_de_site: 0,
        pr_clean_parc: 0,
        pr_clean_parc_evo: 0,
        ip_clean_parc: 0,
        ip_clean_parc_evo: 0,
        pc_totale: 0,
        disponibilite_parc: 0,
        disponibilite_parc_evo: "_ ",
        pertes_recouvrables: "_ ",
        pertes_vs_modele_energie: "_ ",
        pertes_vs_modele_energie_evo: "_ ",
        major_alarms: 0,
        minor_alarms: 0,
        without_alarms: 0,
      },
      site: [],
      list_alarms: [],
      checklistStatus: {},
    };
  },

  watch: {
    selected_mode: {
      handler(val) {
        webconf.debugLog(
          "watch",
          this.script_name,
          "selected_mode",
          `mode : ${this.selected_mode}`
        );

        let method = "";
        if (val === "_historique_perf_") {
          method = "getInstallationLoss";
          this.$root.$emit("close-go-to-site");
        }

        if (method.length > 0) {
          this.$store
            .dispatch(method, {
              id_ref_site: this.$route.params.id,
              start: this.$store.state.parametersStore.dates.start,
              end: this.$store.state.parametersStore.dates.end,
            })
            .then(() => {
              this.setInstallation();
            });
        }
      },
      deep: true,
    },

    dateRange_two: {
      handler() {
        webconf.debugLog(
          "watch",
          this.script_name,
          "dates",
          this.$store.state.parametersStore.dates
        );

        let method = "";
        if (this.selected_mode === "_historique_perf_") {
          method = "getInstallationLoss";
        }

        if (method.length > 0) {
          this.$store
            .dispatch(method, {
              id_ref_site: this.$route.params.id,
              start: this.$store.state.parametersStore.dates.start,
              end: this.$store.state.parametersStore.dates.end,
            })
            .then(() => {
              this.setInstallation();
            });
        }
      },
      immediate: true,
      deep: true,
    },
    $route: {
      handler() {
        if (this.$route.query.selected_date) {
          this.selectedDate = this.$route.query.selected_date;
        }

        if (!this.selectedDate) this.selectedDate = localStorage.date;

        this.setDefaultDateToYesterday();
        this.takedades();
      },
      immediate: true,
      deep: true,
    },

    "$root.$i18n.locale": {
      handler() {
        //this.takedades()
      },
      immediate: true,
      deep: true,
    },
    "$route.params.selected_date": function (newDate) {
      this.selectedDate = newDate;
      if (!this.selectedDate) this.selectedDate = localStorage.date;
      this.setDefaultDateToYesterday();
    },
    cur_install_id: {
      immediate: true,
      handler(newId) {
        this.installation =
          this.installations.find((x) => x.installation_id === newId) || null;
        if (this.installation) this.initinstallation();
      },
    },
  },

  mounted() {
    this.setChangebuttonname(2);
    this.initinstallation();
    this.site.push(this.cur_install_id);
    this.selectedDate = this.$route.query.selected_date || "";

    if (!this.selectedDate) this.selectedDate = localStorage.date;
    this.setDefaultDateToYesterday();
    this.isDateModified = this.dateRange !== this.maxDate;
    this.$store.dispatch("setInstallationMaxDates", {
      start_date: this.installation.audit_start_date,
      end_date: this.installation.audit_end_date,
    });
    this.$store.dispatch("setInstallationAuditDate", {
      start_date: this.installation.audit_start_date,
      end_date: this.installation.audit_end_date,
    });
    this.$store.dispatch("setInstallationExpertDate", {
      start_date: this.installation.audit_start_date,
      end_date: this.installation.audit_end_date,
    });
  },

  computed: {
    ...mapGetters(["role", "installations", "cur_install_id", "constants"]),
    isInsideDetailPerf() {
      // This assumes you pass `selected_mode` as a prop or state
      return this.$store.state.smartguard.selected_mode === "_historique_perf_";
    },

    pageLabel() {
      // If inside SmartGuard detail perf
      if (this.isInsideDetailPerf) {
        return this.installation_name;
      }

      return this.setPageLabel(); // fallback to normal logic
    },
    isWarningCondition() {
      const result = Math.abs(1 - this.list_dashboard.nb_de_site);
      return result != 0 && this.dateRange === this.maxDate;
    },
    changelable() {
      return this.viewMode === "evolution" || this.viewMode === "mixed"
        ? "_exit_"
        : "_alarmes_";
    },
  },

  methods: {
    initinstallation() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");

      this.installations.forEach((element) => {
        if (element.installation_id == this.cur_install_id) {
          this.installation = element;
        }
      });

      this.dates[0] = this.installation.audit_start_date;
      this.dates[1] = `${year}-${month}-${day}`;
      this.updateDateRange();
      this.setdates();
    },
    resetToMaxDate() {
      this.dateRange = this.maxDate;
      this.tempDateRange = this.maxDate;
      this.isDateModified = false;
      this.isDateModifiedHistorie = false;
      this.takedades();
    },

    setInstallation() {
      this.installation = this.$store.getters.installations.find(
        (x) => x.id == this.$route.params.id
      );

      webconf.debugLog(
        "methods",
        this.script_name,
        "setInstallation",
        this.installation
      );
    },
    setChangebuttonname(value) {
      if (value === 0) {
        this.viewMode = "evolution";
      } else if (value === 1) {
        this.viewMode = "mixed";
      } else if (value === 2) {
        this.viewMode = "alarmes";
      }
 
    },

    setDefaultDateToYesterday() {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      const defaultDate = yesterday.toISOString().slice(0, 10);
      if (!this.selectedDate) {
        this.dateRange = defaultDate;
        this.tempDateRange = defaultDate;
      } else {
        this.dateRange = this.selectedDate;
        this.tempDateRange = this.selectedDate;
      }
    },

    async getChecklistStatus() {
      if (this.$store.getters.cur_install_id !== undefined) {
        await api
          .getChecklistStatus(
            this.$store.getters.cur_install_id,
            this.dateRange
          )
          .then((res) => {
            this.checklistStatus = res.data;
          });
      }
    },

    async take_list_parc() {
      let elm = [];
      elm.push(this.cur_install_id);
      //this.site = elm;
      // Ensure list_fleet is updated with the correct data
      this.list_dashboard = { ...this.defaultDashboard };
      if (elm.length > 0) {
        try {
          const response = await api.getlistfleet({
            fleet: elm,
            dates: this.dateRange,
            country_lang_code: this.$root.$i18n.locale,
          });
          this.list_fleet = response.data || [];
          this.list_dashboard = response.data.total
            ? { ...response.data.total }
            : { ...this.defaultDashboard };
        } catch (error) {
          console.error("Error fetching getlistfleet:", error);
          this.list_fleet = [];
          this.list_dashboard = {};
        }
      }
      if (elm.length > 0) {
        try {
          const response_alarm = await api.getlistalarms({
            alarms: elm,
            dates: this.dateRange,
            country_lang_code: this.$root.$i18n.locale,
          });
          this.list_alarms = response_alarm.data || [];
        } catch (error) {
          console.error("Error fetching getlistalarms:", error);
          this.list_alarms = [];
        }
      }

      this.list_dashboard.major_alarms = 0;
      this.list_dashboard.minor_alarms = 0;

      this.list_alarms.forEach((alarm) => {
        switch (alarm.criticity_info) {
          case "_critique_":
            this.list_dashboard.major_alarms += 1;
            break;
          case "_severe_":
            this.list_dashboard.minor_alarms += 1;
            break;
        }
      });
      this.list_dashboard.without_alarms =
        this.list_dashboard.major_alarms === 0 &&
        this.list_dashboard.minor_alarms === 0
          ? 1
          : 0;

      const currentHour = new Date().getHours();     
      if (this.dateRange === this.maxDate) {
        if (currentHour >= 0 && currentHour <= 7) {          
          this.color_warning_msg = "orange";
          this.warning_error_msg = `Données en cours d’acquisition`;          
          this.showAlert = true;
        } else if (currentHour >= 8) {
          this.color_warning_msg = "#ff0000";
          this.warning_error_msg = `Données manquantes pour ce site `;
          this.showAlert = true;
        }
      }
    },

    takedades() {     
      localStorage.date = this.tempDateRange;
      this.dateRange = this.tempDateRange;
      this.menu = false;
      this.take_list_parc();
      this.getChecklistStatus();     
    },

    updateDateRange() {
      if (!this.dates || this.dates.length === 0) {
        this.dateRange_two = "";
        return;
      }

      if (!this.dates[1]) {
        // Only update the HISTORY date — NOT the main date
        this.dateRange_two = `${this.dates[0]} -> ${this.dates[0]}`;
        return;
      }

      // Sort and store normally
      let [start, end] = this.dates.sort((a, b) => new Date(a) - new Date(b));
      this.dateRange_two = `${start} -> ${end}`;
    },

    setdates() {
      this.$store.dispatch("setInstallationAuditDate", {
        start_date: this.dates[0],
        end_date: this.dates[1],
      });
    },

    validatedate() {
      this.menu_two = false;
      this.updateDateRange();
      this.setdates();
    },
  },
};
</script>

<style scoped>
 .btn {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 50px;
} 
.d-flex.align-center {
  min-height: 0px; /* adjust as needed */
  min-width: auto;
  
}
.date_selector_smart {
  width: 200px;
  margin-left: 80px;
  margin-bottom: 10px;
  position: relative; /* Important for absolute children */
}

.alert-wrapper {
  position: relative; /* contains the icon and alert */
}

.alert-icon {
  position: absolute;
  top: 5px; /* adjust vertical placement */
  left: -30px; /* adjust horizontal placement */
  cursor: pointer;
}

.alert-popup {
  position: absolute;
  top: 40px; /* distance from icon */
  left: -20px;
  width: 400px;
  z-index: 10;
}

.fleet-date-smart .v-input__slot {
  min-height: 40px !important; /* Force standard Vuetify height */
  height: 40px !important;
  display: flex !important;
  align-items: center !important;
  padding: 0 12px !important;
}

::v-deep .fleet-date-smart .v-text-field__details {
  display: none !important;
  margin: 0 !important;
  padding: 0 !important;
  min-height: 0 !important;
}
.v-menu__content {
  min-width: 290px !important;
}

.v-application a {
  text-decoration: none;
}

.v-chip {
  cursor: pointer;
}

.input {
  border: 1px solid #ededed !important;
  border-radius: 5px;
  cursor: pointer;
  padding: 1px 10px;
}

.mode-choice {
  text-transform: capitalize;
  font-size: 18px;
  padding: 8px 20px;
  font-weight: 500;
  border-radius: 4px 4px 0 0;
}

.mode-choice.active {
  background-color: white;
  cursor: default;
}

.mode-choice:not(.active) {
  background-color: rgba(100%, 100%, 100%, 0.5);
  cursor: pointer;
}
</style>

<style>
/* Target the ID directly to increase priority */
#content.v-main {
  padding-top: 64px !important;
}
</style>